const firmaEnumerators = {
  estado: [
    'Pendiente',
    'Rechazada',
    'Aprobada',
  ],
  objetivo: [
    'Aceptar',
    'Validar',
    'Realizar',
  ],
  tipoFirma: ['individual', 'parcial'],
  tipoOperacion: ['Tarea', 'Planificacion', 'Incidente'],
};

export default firmaEnumerators;
